module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"NextLevelResume.co","short_name":"Resume","start_url":"/","background_color":"#1B2A4E","description":"A Beautiful Resume in 5 Minutes","theme_color":"#1B2A4E","display":"minimal-ui","icon":"src/images/diy-logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"e407e27d81846ed8bc511305f1cabf35"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
